export default __webpack_public_path__ + "static/media/portfolio-80.adf7f367.jpg";